import { Insight } from '@/services/dashboard-service/dashboard.service.types';
import { calculatePercentageDecimal, sumDataValue } from '@/utils/helpers';
import { Col, Flex, Row } from 'antd';
import styles from './trending-topics-details.module.scss';

interface TrendingTopicsDetailsProps {
  topicsData: Insight;
}

export function TrendingTopicsDetails({ topicsData }: TrendingTopicsDetailsProps) {
  const total = sumDataValue(topicsData);

  const sortedTopics = Object.entries(topicsData).sort(([, valueA], [, valueB]) => {
    return (valueB as number) - (valueA as number);
  });

  return (
    <Flex vertical>
      <Flex className={styles.titleWrapper}>
        <p className={styles.nameColumn}>Name</p>
        <p>Count</p>
        <p>Percent</p>
      </Flex>
      {sortedTopics.map(([key, value]) => {
        const count = value as number;
        const percentage = calculatePercentageDecimal(count, total);

        return (
          <Row key={key} className={styles.row} style={{ width: '100%' }}>
            <Col className={styles.keyColumn}>
              <span>{`"${key}"`}</span>
            </Col>
            <Col className={styles.col}>
              <span>{count !== null ? count : '-'}</span>
            </Col>
            <Col className={styles.col}>
              <span>{`${percentage}%`}</span>
            </Col>
          </Row>
        );
      })}
    </Flex>
  );
}
